/* Cart page (sections/main-cart.liquid): quantity and remove buttons from snippets/cart-items.liquid.
   Calls QS.cart.change (theme.js), then re-renders this section through the Section Rendering API.
   Falls back to a full reload if anything goes wrong. */
(() => {
  'use strict';
  if (customElements.get('q-cart-page')) return;

  customElements.define('q-cart-page', class extends HTMLElement {
    connectedCallback() {
      this.onClick = (event) => {
        const btn = event.target.closest('[data-qty-change]');
        if (!btn || !this.contains(btn)) return;
        event.preventDefault();
        this.change(btn);
      };
      // Cart changes made elsewhere (another tab is not covered; same-page events are).
      this.onUpdated = () => { if (!this.pending) this.rerender(); };
      this.addEventListener('click', this.onClick);
      document.addEventListener('cart:updated', this.onUpdated);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      document.removeEventListener('cart:updated', this.onUpdated);
    }

    focusKey(btn) {
      const line = Number(btn.dataset.line);
      if (btn.classList.contains('cart-item__remove')) return { line, kind: 'remove' };
      const group = btn.closest('.qty');
      const buttons = group ? [...group.querySelectorAll('[data-qty-change]')] : [];
      return { line, kind: buttons.indexOf(btn) === 0 ? 'minus' : 'plus' };
    }

    async change(btn) {
      if (this.pending) return;
      const line = Number(btn.dataset.line);
      const quantity = Math.max(0, Number(btn.dataset.qtyChange) || 0);
      const item = btn.closest('.cart-item');
      const key = this.focusKey(btn);

      if (!window.QS || !window.QS.cart || !line) { window.location.reload(); return; }

      this.pending = true;
      this.setError('');
      if (item) item.classList.add('is-busy');
      try {
        await window.QS.cart.change(line, quantity);
        await this.rerender(key);
      } catch (err) {
        if (item) item.classList.remove('is-busy');
        const description = err && err.data && err.data.description;
        this.setError(description || (window.QS.strings && window.QS.strings.cartError) || (err && err.message) || '');
      } finally {
        this.pending = false;
      }
    }

    async rerender(key) {
      const id = this.dataset.sectionId;
      try {
        const url = window.location.pathname + '?section_id=' + encodeURIComponent(id);
        const res = await fetch(url, { headers: { Accept: 'text/html' } });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const fresh = doc.querySelector('[data-cart-page-content]');
        const current = this.querySelector('[data-cart-page-content]');
        if (!fresh || !current) throw new Error('Missing cart content');

        // Keep an order note the shopper is typing.
        const note = current.querySelector('textarea[name="note"]');
        const freshNote = fresh.querySelector('textarea[name="note"]');
        if (note && freshNote) freshNote.value = note.value;
        // No fade-ins on a re-render.
        fresh.querySelectorAll('img.img').forEach((img) => img.classList.add('is-loaded'));
        fresh.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-revealed'));

        current.replaceWith(fresh);
        if (window.QS && window.QS.refresh) window.QS.refresh(this);
        this.announce(fresh);
        this.restoreFocus(key);
      } catch (err) {
        window.location.reload();
      }
    }

    announce(root) {
      const status = this.querySelector('[data-cart-page-status]');
      const source = root.querySelector('[data-cart-page-announce]');
      if (status && source) status.textContent = source.textContent.trim();
    }

    restoreFocus(key) {
      if (!key) return;
      let target = null;
      if (key.kind !== 'remove') {
        const item = this.querySelector('.cart-item[data-line="' + key.line + '"]');
        const buttons = item ? item.querySelectorAll('.qty [data-qty-change]') : [];
        target = key.kind === 'minus' ? buttons[0] : buttons[buttons.length - 1];
      }
      if (!target) target = this.querySelector('[data-cart-page-title]');
      if (target) target.focus({ preventScroll: true });
    }

    setError(message) {
      const el = this.querySelector('[data-cart-page-error]');
      if (!el) return;
      el.textContent = message;
      el.hidden = !message;
    }
  });
})();
